import { useQuery, type QueryKey, type UseQueryOptions } from "@tanstack/react-query";
import { useAxios } from "auth-sdk";
import type { AxiosError, AxiosRequestConfig } from "axios";

export const useQueryWithInitialData = <T>(
  queryKey: QueryKey,
  url: string,
  initialData?: T,
  body?: AxiosRequestConfig,
  method = "post",
  config: Omit<UseQueryOptions<T, AxiosError, T, QueryKey>, "queryKey"> = {}
) => {
  const client = useAxios();
  const queryFn = async (): Promise<any> => {
    const { data } = await client[method](url, body);
    return data.data || data;
  };
  return useQuery<T, AxiosError, T, QueryKey>({
    queryKey,
    queryFn,
    initialData,
    refetchOnMount: false,
    ...config,
  });
};
